import { createThunkEffect } from "../../utilities/ActionUtility";
import * as UserDetailsEffect from "./UserDetailsEffect";

export const REQUEST_ALL_USERS_DETAILS = "UserDetailsEffect.REQUEST_ALL_USERS_DETAILS";
export const REQUEST_ALL_USERS_DETAILS_FINISHED = "UserDetailsEffect.REQUEST_ALL_USERS_DETAILS_FINISHED";

export function requestAllUsersDetails() {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_USERS_DETAILS, UserDetailsEffect.requestAllUsersDetails);
    };
}

export const REQUEST_USER_DETAILS = "UserDetailsEffect.REQUEST_USER_DETAILS";
export const REQUEST_USER_DETAILS_FINISHED = "UserDetailsEffect.REQUEST_USER_DETAILS_FINISHED";

export function requestUser(userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_USER_DETAILS, UserDetailsEffect.requestUserDetails, userId);
    };
}

export const REQUEST_CURRENT_USER_DETAILS = "UserDetailsEffect.REQUEST_CURRENT_USER_DETAILS";
export const REQUEST_CURRENT_USER_DETAILS_FINISHED = "UserDetailsEffect.REQUEST_CURRENT_USER_DETAILS_FINISHED";

export function requestCurrentUser(userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_CURRENT_USER_DETAILS, UserDetailsEffect.requestUserDetails, userId);
    };
}

export const EDIT_USER_DETAILS = "UserDetailsEffect.EDIT_USER_DETAILS";
export const EDIT_USER_DETAILS_FINISHED = "UserDetailsEffect.EDIT_USER_DETAILS_FINISHED";

export function editUser(user) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, EDIT_USER_DETAILS, UserDetailsEffect.editUserDetails, user);
    };
}

export const SEND_INVITATION = "UserDetailsEffect.SEND_INVITATION";
export const SEND_INVITATION_FINISHED = "UserDetailsEffect.SEND_INVITATION_FINISHED";

export function sendInvitation(userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, SEND_INVITATION, UserDetailsEffect.sendInvitation, userId);
    };
}

export const REQUEST_LOCK_USER = "UserDetailsEffect.REQUEST_LOCK_USER";
export const REQUEST_LOCK_USER_FINISHED = "UserDetailsEffect.REQUEST_LOCK_USER_FINISHED";

export function lockUser(userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_LOCK_USER, UserDetailsEffect.lockUser, userId);
    };
}

export const REQUEST_UNLOCK_USER = "UserDetailsEffect.REQUEST_UNLOCK_USER";
export const REQUEST_UNLOCK_USER_FINISHED = "UserDetailsEffect.REQUEST_UNLOCK_USER_FINISHED";

export function unlockUser(userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_UNLOCK_USER, UserDetailsEffect.unlockUser, userId);
    };
}

export const REQUEST_INIT_USER = "UserDetailsEffect.REQUEST_INIT_USER";
export const REQUEST_INIT_USER_FINISHED = "UserDetailsEffect.REQUEST_INIT_USER_FINISHED";

export function initUser(userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_INIT_USER, UserDetailsEffect.initUser, userId);
    };
}

export const REQUEST_SAVE_USER_DETAILS = "UserDetailsEffect.REQUEST_SAVE_USER_DETAILS";
export const REQUEST_SAVE_USER_DETAILS_FINISHED = "UserDetailsEffect.REQUEST_SAVE_USER_DETAILS_FINISHED";

export function saveUserDetails(userId, details) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_SAVE_USER_DETAILS, UserDetailsEffect.saveUserDetails, userId, details);
    };
}

export const REQUEST_RESET_PASSWORD = "UserDetailsEffect.REQUEST_RESET_PASSWORD";
export const REQUEST_RESET_PASSWORD_FINISHED = "UserDetailsEffect.REQUEST_RESET_PASSWORD_FINISHED";

export function resetPassword(userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_RESET_PASSWORD, UserDetailsEffect.resetPassword, userId);
    };
}

export const REQUEST_ACCEPT_PRIVACY_NOTICE = "UserDetailsEffect.REQUEST_ACCEPT_PRIVACY_NOTICE";
export const REQUEST_ACCEPT_PRIVACY_NOTICE_FINISHED = "UserDetailsEffect.REQUEST_ACCEPT_PRIVACY_NOTICE_FINISHED";

export function acceptPrivacyNotice(userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ACCEPT_PRIVACY_NOTICE, UserDetailsEffect.acceptPrivacyNotice, userId);
    };
}

export const REQUEST_DELETE_USER = "UserDetailsEffect.REQUEST_DELETE_USER";
export const REQUEST_DELETE_USER_FINISHED = "UserDetailsEffect.REQUEST_DELETE_USER_FINISHED";

export function deleteUser(userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_DELETE_USER, UserDetailsEffect.deleteUser, userId);
    };
}
